import React from 'react';
import PropTypes from 'prop-types';

import Heading, {
  HeadingLevels,
  HeadingDefaultLevel,
} from '../Heading';

const defaultProps = {
  level: HeadingDefaultLevel,
  className: '',
};

const propTypes = {
  level: PropTypes.oneOf(HeadingLevels),
  className: PropTypes.string,
  children: PropTypes.string.isRequired,
};

const Title = ({
  level,
  className,
  children,
}) => (
  <Heading
    level={level}
    className={className}
  >
    {children}
  </Heading>
);

Title.defaultProps = defaultProps;
Title.propTypes = propTypes;

export default Title;
